import { ENV } from '@/config/env';

export const canEditOwnCompany = ({
  userRoleId,
  userCompanyId,
  currentCompanyId,
}: {
  userRoleId?: number;
  userCompanyId?: number;
  currentCompanyId?: number;
}) => {
  const generalAdminId = 2;
  const isOwnCompany = userCompanyId === currentCompanyId;

  return userRoleId === generalAdminId && isOwnCompany;
};

export const editCompanyUrls = {
  services: `${ENV.APRO_URL}/new_administration/services`,
  locations: `${ENV.APRO_URL}/new_administration/locations`,
  providers: `${ENV.APRO_URL}/new_administration/service_providers`,
  company: `${ENV.APRO_URL}/company_settings`,
};
